import React from "react"
import { locationType } from "../utils/UserLocationUtils"

export const LayoutContext = React.createContext<{
  userLocation?: locationType
}>({
  userLocation: undefined,
})
